import { normalizeAllowedRedirectPath } from "@miadvg/auth-gateway";

/**
 * Slug registered on `auth.taxrise.com` for this app. Must match byte-for-byte
 * what platform configured on the gateway, otherwise sign-in fails with a
 * generic "app not found" before access checks even run.
 */
export const CLIENT_CONTEXT_STAFF_APP_SLUG = "client-context";
export const CLIENT_CONTEXT_STAFF_AUTH_CALLBACK_PATH = "/auth/callback";
export const CLIENT_CONTEXT_STAFF_SIGN_OUT_PATH = "/api/auth/sign-out";

/**
 * Normalize the post-sign-in `redirectTo` the gateway hands back to us. Only
 * `/client-context` is a valid landing — any other path is dropped to the
 * fallback so a malformed or attacker-supplied redirect can't bounce a user
 * to an off-app URL. (Note: `/client-context` without `?accountId=` will
 * still render an `EmbedError` at the page; that's the right behavior —
 * tell the user their link is incomplete instead of guessing.)
 */
export function normalizeClientContextStaffRedirectPath(
  rawValue: string | null | undefined,
): string {
  return normalizeAllowedRedirectPath(rawValue, {
    fallback: "/client-context",
    allowedPrefixes: ["/client-context"],
  });
}
